module.exports = __webpack_public_path__ + "static/img/setting.42fdac0b.svg";